import React, { useState } from 'react';
import { Layout } from 'antd';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import Home from '../../components/Home';
import Preferencias from './Establecimiento/Preferencias';
import Docentes from './Establecimiento/Docentes';
import Cursos from './Establecimiento/Cursos';
import CredencialesAccesoDocentes from './Establecimiento/CredencialesAccesoDocentes';
import UsoPlataforma from './Establecimiento/UsoPlataforma';
import MigracionUsuarios from './Establecimiento/MigracionUsuarios';
import Inscripciones from './Inscripciones/Inscripciones';
import CrearPago from './Pagos/CrearPagos';
import CrearPagoInscripcion from './Pagos/CrearPagoInscripcion';
import BuscarRecibo from './Pagos/BuscarRecibo';
import ReportePagosFechas from './Pagos/ReportePagosFechas';
import PagosHoy from './Pagos/PagosHoy';
import Insolventes from './Pagos/Insolventes';
import ListadoSolventes from './Pagos/ListadoSolventes';
import EliminarPagos from './Pagos/EliminarPagos';
import EditarAlumno from './Alumnos/EditarAlumno';
import ListadoAlumnos from './Alumnos/FiltrosInscripciones';
import EstudiantesRetirados from './Alumnos/EstudiantesRetirados';
import ListadoResponsables from './Alumnos/ListadoResponsables';
import FamiliaCRUD from './Alumnos/FamiliaCRUD';
import CredencialesAcceso from './Estudiantes/CredencialesAcceso';
import AsignacionCursos from './ConfigurarAcademico/AsignacionCursos/AsignacionCursos';
import AsignacionMasiva from './ConfigurarAcademico/AsignacionCursos/AsignacionMasiva';
import Unidades from './ConfigurarAcademico/Unidades/Unidades';
import Actividades from './ConfigurarAcademico/Actividades/Actividades';
import CalificarActividad from './ConfigurarAcademico/Calificaciones/CalificarActividad';
import MisSolicitudesReapertura from './ConfigurarAcademico/MisSolicitudesReapertura';
import GestionarSolicitudesReapertura from './Administrador/GestionarSolicitudesReapertura';
import CierreUnidades from './Administrador/CierreUnidades';
import BoletaCalificaciones from './Administrador/BoletaCalificaciones';
import ActividadesPendientesDocentes from './Administrador/ActividadesPendientesDocentes';
import PromediosGrado from './Administrador/PromediosGrado';
import SolicitudesRectificacion from './Administrador/SolicitudesRectificacion';
import RectificacionNotas from './Docente/RectificacionNotas';
import RectificacionCalificar from './Docente/RectificacionCalificar';
import ReasignacionCursos from './ConfigurarAcademico/ReasignacionCursos/ReasignacionCursos';
import RendimientoEstudiantil from './Administrador/RendimientoEstudiantil';
import ListadoCotejo from './Administrador/ListadoCotejo';
import ActividadesDirector from './Administrador/ActividadesDirector';
import ListadoCotejoCurso from './Academico/ListadoCotejoCurso';
import ConfigurarDias from './Establecimiento/ConfigurarDias';
import PublicacionNotas from './Establecimiento/PublicacionNotas';
import AulaCandelaria from './Academico/AulaCandelaria/AulaCandelaria';
import CalendarioTareas from './Academico/CalendarioTareas/CalendarioTareas';
import BoletaCalificacionesFamilia from './Estudiantes/BoletaCalificacionesFamilia';
import ActividadesFamilia from './Estudiantes/ActividadesFamilia';
import './Dashboard.css';

const { Content } = Layout;

const Dashboard = ({ user }) => {
  const [collapsed, setCollapsed] = useState(false);

  if (!user) return null;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout style={{ marginLeft: collapsed ? 80 : 250, transition: 'margin-left 0.2s' }}> {/* Ajusta el margen según el estado */}
        <Header user={user} />
        <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 'calc(100vh - 64px)' }}>
          <Routes>
            <Route path="/" element={<Home
              usuario={user}
              onLogout={() => {
                window.location.href = '/login'; // ← Redirige al login
              }}
/>} />
            <Route path="/preferencias" element={<Preferencias />} />
            <Route path="/establecimiento/docentes" element={<Docentes />} />
            <Route path="/establecimiento/cursos" element={<Cursos />} />
            <Route path="/establecimiento/credenciales-docente" element={<CredencialesAccesoDocentes />} />
            <Route path="/uso-plataforma" element={<UsoPlataforma />} />
            <Route path="/migracion-usuarios" element={<MigracionUsuarios />} />
            <Route path="/inscripciones/inscripciones" element={<Inscripciones />} />
            <Route path="/pagos/crear" element={<CrearPago />} />
            <Route path="/pagos/eliminar" element={<EliminarPagos />} />
            <Route path="/pagos/inscripcion" element={<CrearPagoInscripcion />} />
            <Route path="/pagos/buscar-recibo" element={<BuscarRecibo />} />
            <Route path="/pagos/reporte-fechas" element={<ReportePagosFechas />} />
            <Route path="/pagos/pagos-hoy" element={<PagosHoy />} />
            <Route path="/pagos/insolventes" element={<Insolventes />} />
            <Route path="/pagos/solventes" element={<ListadoSolventes />} />
            <Route path="/alumnos/editar" element={<EditarAlumno />} />
            <Route path="/alumnos/listado" element={<ListadoAlumnos />} />
            <Route path="/alumnos/estudiantes-retirados" element={<EstudiantesRetirados />} />
            <Route path="/alumnos/listado-responsables" element={<ListadoResponsables />} />
            <Route path="/alumnos/familias" element={<FamiliaCRUD />} />
            <Route path="/estudiantes/credenciales-acceso" element={<CredencialesAcceso />} />
            <Route path="/academico/aula-candelaria" element={<AulaCandelaria />} />
            <Route path="/academico/calendario-tareas" element={<CalendarioTareas />} />
            <Route path="/configurar-academico/asignacion-cursos" element={<AsignacionCursos />} />
            <Route path="/configurar-academico/asignacion-masiva" element={<AsignacionMasiva />} />
            <Route path="/configurar-academico/configurar-unidades" element={<Unidades />} />
            <Route path="/configurar-academico/configurar-actividades" element={<Actividades />} />
            <Route path="/configurar-academico/calificar-actividad" element={<CalificarActividad />} />
            <Route path="/configurar-academico/mis-solicitudes-reapertura" element={<MisSolicitudesReapertura />} />
            <Route path="/configurar-academico/reasignacion-cursos" element={<ReasignacionCursos />} />
            <Route path="/administrador/gestionar-solicitudes-reapertura" element={<GestionarSolicitudesReapertura />} />
            <Route path="/administrador/cierre-unidades" element={<CierreUnidades user={user} />} />
            <Route path="/administrador/boleta-calificaciones" element={<BoletaCalificaciones />} />
            <Route path="/administrador/actividades-pendientes-docentes" element={<ActividadesPendientesDocentes />} />
            <Route path="/administrador/promedios-grado" element={<PromediosGrado />} />
            <Route path="/administrador/solicitudes-rectificacion" element={<SolicitudesRectificacion />} />
            <Route path="/administrador/rendimiento-estudiantil" element={<RendimientoEstudiantil />} />
            <Route path="/administrador/listado-cotejo" element={<ListadoCotejo />} />
            <Route path="/administrador/cuadro-promedios" element={<ListadoCotejo key="cuadro-promedios" titulo="Cuadro de Promedios" endpoint="/boleta-calificaciones/cuadro-promedios" archivo="Promedios" conCiclo={false} />} />
            <Route path="/administrador/actividades-director" element={<ActividadesDirector />} />
            <Route path="/academico/listado-cotejo-curso" element={<ListadoCotejoCurso user={user} />} />
            <Route path="/docente/rectificacion-notas" element={<RectificacionNotas />} />
            <Route path="/docente/rectificacion-calificar" element={<RectificacionCalificar />} />
            <Route path="/establecimiento/configurar-dias" element={<ConfigurarDias />} />
            <Route path="/establecimiento/publicacion-notas" element={<PublicacionNotas />} />
            <Route path="/estudiantes/mis-calificaciones" element={<BoletaCalificacionesFamilia />} />
            <Route path="/estudiantes/mis-actividades" element={<ActividadesFamilia />} />
            {/* Agrega más rutas */}
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;